(function () {
  'use strict';

  angular.module('ringbaPortal').component('numberOptions', {
    bindings: {
      selectedCountry: '<',
      numberRestrictions: '<',
      assignmentSettings: '='
    },
    controller: NumberOptionsController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/number-options/number-options.view.html'
  });

  function NumberOptionsController(
    $translate,
    accountsService,
    phoneLookupService
  ) {
    'ngInject';

    const vm = this;

    vm.$onChanges = onChanges;
    vm.getExampleNumbers = getExampleNumbers;
    vm.startWithEnabled = startWithEnabled;
    vm.numberTypeToggled = numberTypeToggled;
    $translate('NUMBER_POOL_NUMBER_TYPE_TT').then(function (translation) {
      vm.numberTypeTooltip = translation;
    });

    function onChanges(changesObj) {
      if (changesObj.numberRestrictions || changesObj.selectedCountry) {
        vm.showTollFreeToggle = _checkSelectedCountryForTollFree(vm.selectedCountry) && _checkNumberRestrictionsForTollFree(vm.numberRestrictions);
        vm.keepTFEnabled = vm.numberRestrictions && _checkIfCountryAddressRequirementsSatisfyForTollFree(vm.selectedCountry) && !_checkNumberRestrictionsForDID(vm.numberRestrictions);

        vm.assignmentSettings = vm.assignmentSettings || {};
        vm.assignmentSettings.isTollFree = vm.keepTFEnabled;
      }
    }

    function getExampleNumbers() {
      phoneLookupService.lookupNumber(accountsService.currentAccountId, vm.assignmentSettings)
        .then(function (response) {
          vm.exampleNumbers = response.data.numbers;
        });
    }

    function startWithEnabled() {
      if (vm && vm.currentNumberPool && vm.currentNumberPool.id) {
        return false;
      }
      if (vm && vm.assignmentSettings && vm.assignmentSettings.isTollFree) {
        return false;
      }

      if (vm && vm.selectedCountry) {
        if (vm.selectedCountry.countryCode === 'FR') {
          return false;
        }
      }
      return false;
    }

    function numberTypeToggled(isTollFree) {
      vm.assignmentSettings.isTollFree = isTollFree;
    }

    function _checkIfCountryAddressRequirementsSatisfyForTollFree(selectedCountry) {
      return _checkSelectedCountryForTollFree(selectedCountry) && selectedCountry.addressRequirementFullfilledForTollFreeNumbers;
    }

    function _checkSelectedCountryForTollFree(selectedCountry) {
      return selectedCountry && selectedCountry.hasTollFreeNumbers;
    }

    function _checkNumberRestrictionsForTollFree(numberRestrictions) {
      return !numberRestrictions || (numberRestrictions && numberRestrictions.allowTF);
    }

    function _checkNumberRestrictionsForDID(numberRestrictions) {
      return numberRestrictions && numberRestrictions.allowDID;
    }
  }
})();
